import { Card } from '@features/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { AddonForm } from '@features/admin/productsAddons';
import { AddonFormData, schemaAddons } from '@src/types/productsAddons.ts';
import { useProductOptions } from '@hooks/useProductOptions.tsx';
import { getProductDetail, saveProductAddon } from '@src/services/products.ts';
import { buildProductAddons, mapperProductAddons } from '@lib/products.ts';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEffect, useRef } from 'react';

export const AddonEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const hasRun = useRef(false);
  const { productOptions } = useProductOptions();

  const handleSubmitForm = async (data: AddonFormData) => {
    try {
      const makeData = buildProductAddons(data);

      await saveProductAddon(Number(id), makeData);
    } catch {
      toast.error('Something went wrong. Please try again later.');
    }
  };

  const method = useForm<AddonFormData>({
    resolver: yupResolver(schemaAddons),
  });

  useEffect(() => {
    if (!id) return;
    getProductDetail(Number(id))
      .then((res) => {
        const productFormData = mapperProductAddons(res.data);

        method.reset(productFormData);
      })
      .catch(() => {
        if (hasRun.current) return;
        hasRun.current = true;
        alert('Product not found!');
        navigate('/admin/products-addons');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div>
      <div className={'flex'}>
        <div className={'flex flex-col gap-y-2.5 mb-4'}>
          <p className={'text-[23px] font-medium text-blue'}>Addons Edit</p>
          <div className={'h-[2px] w-full bg-blue'} />
        </div>
      </div>
      <Card>
        <FormProvider {...method}>
          <form
            autoComplete="off"
            onSubmit={method.handleSubmit(handleSubmitForm)}
          >
            <AddonForm {...method} productOptions={productOptions} />
          </form>
        </FormProvider>
      </Card>
    </div>
  );
};
